/* globals initialSolutionsExchangeLabState */
import $ from 'jquery';
import 'bootstrap/js/dist/modal';
import DownloadFromShareBase from './sharebasecall.js';

$(document).ready(function () {
	$('#btnLaunch').click(function () {
		var apiUrl = `/api/try/solution/get-lab-url/${initialSolutionsExchangeLabState.Id}`;
		if ($('#btnLaunch').attr('data-flex')) {
			apiUrl = `/api/try/solution/get-flex-url/${initialSolutionsExchangeLabState.Id}`;
		}
		$('#spinner').show();
		$.ajax({
			type: 'GET',
			url: apiUrl,
			cache: false,
		}).then(function (response) {
			if (response.status === "Success") {
				$('#spinner').hide();
				window.open(response.data, '_blank');
			} else if (response.status === "Max labs reached") {
				var labDetails = JSON.parse(response.data);
				$('#spnOpenLab').text(labDetails.RunningLabs[0].LabProfileName);
				$('#hdnOpenLabProfileId').val(labDetails.RunningLabs[0].LabProfileId);
				$('#hdnOpenLabInstanceId').val(labDetails.RunningLabs[0].LabInstanceId);
				$('#lab-controls-modal').modal('show');
			} else {
				alert("An error has occurred. If this continues, please contact us by submitting an Assistance Request.");
				$('#spinner').hide();
			}
		}, function (response) {
			var labDetails = JSON.parse(response.data);
			$('#spnOpenLab').text(labDetails.RunningLabs[0].LabProfileName);
			$('#hdnOpenLabProfileId').val(labDetails.RunningLabs[0].LabProfileId);
			$('#hdnOpenLabInstanceId').val(labDetails.RunningLabs[0].LabInstanceId);
			$('#lab-controls-modal').modal('show');
		});
	});

	$('#btnOpen').click(function () {
		$.ajax({
			type: 'GET',
			url: '/api/try/solution/get-lab-url-by-profile-id/' + $('#hdnOpenLabProfileId').val(),
			cache: false,
			success: function (response) {
				$('#lab-controls-modal').modal('hide');
				$('#spinner').hide();
				window.open(response, '_blank');
			},
			error: function () {
				alert('There was an error opening the active lab.');
				$('#lab-controls-modal').modal('hide');
				$('#spinner').hide();
			}
		});
	});

	$('#btnClose').click(function () {
		$.ajax({
			type: 'POST',
			url: `/api/try/solution/cancel-lab/${initialSolutionsExchangeLabState.Id}/` + $('#hdnOpenLabInstanceId').val(),
			cache: false,
			success: function () {
				alert('Successfully ended the active lab.');
				$('#lab-controls-modal').modal('hide');
				$('#spinner').hide();
			},
			error: function () {
				alert('There was an error ending the active lab.');
				$('#lab-controls-modal').modal('hide');
				$('#spinner').hide();
			}
		});
	});

	$('#btnCancel').click(function () {
		$('#lab-controls-modal').modal('hide');
		$('#spinner').hide();
	});
});
